export const TOP_MENU_ITEMS = [
  {
    name: 'Home',
    linkName: 'home'
  },
  {
    name: 'Products',
    linkName: 'products'
  },
  {
    name: 'Pre-Order AW20',
    linkName: 'pre-order'
  },
  {
    name: 'Shop By Gallery',
    linkName: 'shop-by-gallery'
  },
  {
    name: 'Specials',
    linkName: 'specials'
  },
  {
    name: 'Blog',
    linkName: 'blog'
  },
  {
    name: 'Shows & Events',
    linkName: 'shows&events'
  }
]

export const SIDE_MENU_ITEMS = [
  {
    name: 'HOME',
    icon: 'img/icons/home.svg',
    linkName: 'home',
    pages: [],
    shownCollapse: false
  },
  {
    name: 'DASHBOARD',
    icon: 'img/icons/dashboard.svg',
    linkName: 'dashboard',
    pages: [],
    shownCollapse: false
  },
  {
    name: 'TAG MODULE',
    icon: 'img/icons/tag-module.svg',
    linkName: 'tag-module',
    pages: [],
    shownCollapse: false,
    hasPills: true
  },
  {
    name: 'COLLECTION MODULE',
    icon: 'img/icons/collection.svg',
    linkName: 'collections',
    pages: [],
    shownCollapse: false
  },
  {
    name: 'ORDER / INVOICE HISTORY',
    icon: 'img/icons/invoice.svg',
    linkName: 'order-history.index',
    linkChildrenName: [
      'order-history.index',
      'order-history.draft',
      'order-history.invoices'
    ],
    pages: [
      'order-history.index',
      'order-history.draft',
      'order-history.invoices'
    ],
    shownCollapse: false
  },
  {
    name: 'CONTACTS',
    icon: 'img/icons/contact.svg',
    linkName: 'contacts',
    pages: [],
    shownCollapse: false
  },
  {
    name: 'SETTINGS',
    icon: 'img/icons/settings.svg',
    linkName: 'settings',
    pages: [],
    shownCollapse: true
  }
]

export const ADMIN_SIDE_MENU_ITEMS = [
  {
    name: 'DATABASE MANAGEMENT',
    linkName: '',
    pages: [
      { name: 'Easy Populate', link: 'admin' },
      { name: 'Quick Stock Updater', link: 'stock' },
      { name: 'Promo Code', link: 'coupons' },
      // One entry: the tree and the product grid are tabs of the same module now.
      { name: 'Class & Categories', link: 'brands' }
    ],
    shownCollapse: true
  },
  {
    name: 'IMAGERY',
    linkName: '',
    pages: [
      { name: 'Image Upload', link: 'imagery' },
      { name: 'Image Management', link: 'imagery-management' }
    ],
    shownCollapse: true
  },
  {
    name: 'CONFIGURATION',
    linkName: '',
    pages: [
      { name: 'Orders Config', link: 'orders-config' },
      { name: 'Mega Menu Header', link: 'mega-menu' },
      { name: 'Page Header Descriptions', link: 'page-headers' },
      { name: 'Min Max Settings', link: '' }
    ],
    shownCollapse: true
  },
  {
    name: 'USERS / PERMISSIONS',
    linkName: '',
    pages: [{ name: 'Admin / Rep', link: 'user-permission' },],
    shownCollapse: true
  },
  {
    name: 'CONTACT MANAGEMENT',
    linkName: '',
    pages: [
      { name: 'Accounts', link: 'companies' },
      { name: 'Account Users', link: 'buyers' },
      { name: 'Account Addresses', link: 'addresses' }
    ],
    shownCollapse: true
  },
  {
    name: 'REPORTS',
    linkName: '',
    pages: [
      { name: 'Best Sellers', link: '' },
      { name: 'Contact Activity', link: '' }
    ],
    shownCollapse: true
  }
]

export const TRADESHOW_COLUMNS = [
  {
    key: 'location',
    label: 'Location'
  },
  {
    key: 'show_date',
    label: 'SHOW DATE'
  },
  {
    key: 'show_calendar',
    label: 'SHOW CALENDAR'
  }
]
export const DRAFT_ORDER_COLUMNS = [
  {
    key: 'order_number',
    label: 'Order #'
  },
  {
    key: 'status',
    label: 'Status'
  },
  {
    key: 'order_origin',
    label: 'Order Origin'
  },
  {
    key: 'buyer',
    label: 'Buyer'
  }
]
export const INVOICE_STATUS_COLUMNS = [
  {
    key: 'invoice_number',
    label: 'Invoice #'
  },
  {
    key: 'status',
    label: 'Status'
  },
  {
    key: 'company',
    label: 'Company'
  },
  {
    key: 'po_number',
    label: 'Po #'
  },
  {
    key: 'order_date',
    label: 'Order Date'
  }
]
export const ORDER_COLUMNS = [
  {
    key: 'order_number',
    label: 'Order #'
  },
  {
    key: 'status',
    label: 'Status'
  },
  {
    key: 'bill_to',
    label: 'Bill To'
  },
  {
    key: 'ship_to',
    label: 'Ship To'
  },
  {
    key: 'buyer',
    label: 'Buyer'
  },
  {
    key: 'po_number',
    label: 'Po #'
  },
  {
    key: 'order_date',
    label: 'Order Date'
  },
  {
    key: 'shipping_start_date',
    label: 'Start Ship'
  },
  {
    key: 'location',
    label: 'Location'
  }
]
export const CONTACT_COLUMNS = [
  {
    key: 'company',
    label: 'Company'
  },
  {
    key: 'company_phone',
    label: 'Company Phone'
  },
  {
    key: 'buyer',
    label: 'Buyer'
  },
  {
    key: 'buyer_mobile',
    label: 'Buyer Mobile'
  }
]
export const COLLECTION_COLUMNS = [
  {
    key: 'collection_name',
    label: 'Collection Name'
  },
  {
    key: 'collection_note',
    label: 'Collection Notes'
  },
  {
    key: 'badge',
    label: ''
  }
]

export const ORDER_HISTORY_COLUMNS = [
  {
    key: 'order_number',
    label: 'Order #'
  },
  {
    key: 'status',
    label: 'Status'
  },
  {
    key: 'fishbowl_status',
    label: 'Fishbowl Status'
  },
  {
    key: 'company',
    label: 'Company'
  },
  {
    key: 'order_date',
    label: 'Order Date'
  },
  {
    key: 'ship_date',
    label: 'Ship Date'
  },
  {
    key: 'po_number',
    label: 'Po #'
  },
  {
    key: 'ref_note',
    label: 'Ref Note'
  },
  {
    key: 'order_origin',
    label: 'Order Origin'
  },
  {
    key: 'buyer',
    label: 'Buyer'
  },
  {
    key: 'total',
    label: 'Total'
  },
  {
    key: 'action',
    label: ''
  }
]

export const DRAFT_ORDER_HISTORY_COLUMNS = [
  {
    key: 'id',
    label: ''
  },
  {
    key: 'draft_number',
    label: 'Draft #'
  },
  {
    key: 'company',
    label: 'Company'
  },
  {
    key: 'order_date',
    label: 'Order Date'
  },
  {
    key: 'ship_date',
    label: 'Ship Date'
  },
  {
    key: 'po_number',
    label: 'Po #'
  },
  {
    key: 'ref_note',
    label: 'Ref Note'
  },
  {
    key: 'bill_to',
    label: 'Bill To'
  },
  {
    key: 'ship_to',
    label: 'Ship To'
  },
  {
    key: 'buyer',
    label: 'Buyer'
  },
  {
    key: 'total',
    label: 'Total'
  },
  {
    key: 'action',
    label: ''
  }
]

export const INVOICE_HISTORY_COLUMNS = [
  {
    key: 'invoice_number',
    label: 'Invoice #'
  },
  {
    key: 'status',
    label: 'Status'
  },
  {
    key: 'company',
    label: 'Company'
  },
  {
    key: 'order_date',
    label: 'Order Date'
  },
  {
    key: 'ship_date',
    label: 'Ship Date'
  },
  {
    key: 'due_date',
    label: 'Due Date'
  },
  {
    key: 'po_number',
    label: 'Po #'
  },
  {
    key: 'ref_note',
    label: 'Ref Note'
  },
  {
    key: 'total_shipped',
    label: 'Total Shipped'
  },
  {
    key: 'balance',
    label: 'Balance'
  },
  {
    key: 'action',
    label: ''
  }
]

export const ADMIN_CONTACT_COLUMNS = [
  {
    key: 'company',
    label: 'Company',
    sortable: true
  },
  {
    key: 'phone',
    label: 'Phone',
    sortable: true
  },
  {
    key: 'mobile',
    label: 'Mobile',
    sortable: true
  },
  {
    key: 'buyer',
    label: 'Buyer',
    sortable: true
  },
  {
    key: 'buyer_email',
    label: 'Buyer Email',
    sortable: true
  }
]

export const COMPANY_ORDER_HISTORY_COLUMNS = [
  {
    key: 'order_number',
    label: 'Order #'
  },
  {
    key: 'status',
    label: 'Status'
  },
  {
    key: 'company',
    label: 'Company'
  },
  {
    key: 'order_date',
    label: 'Order Date'
  },
  {
    key: 'ship_date',
    label: 'Ship Date'
  },
  {
    key: 'po_number',
    label: 'Po #'
  },
  {
    key: 'ref_note',
    label: 'Ref Note'
  },
  {
    key: 'bill_to',
    label: 'Bill To'
  },
  {
    key: 'ship_to',
    label: 'Ship To'
  },
  {
    key: 'buyer',
    label: 'Buyer'
  }
]

export const ORDER_STATUS = {
  DRAFT: 1,
  COMPLETED: 2,
  BACKORDER: 3,
}

export const DEFAULT_DISCOUNT_ITEMS = [
  { value: 10, label: '10%' },
  { value: 15, label: '15%' },
  { value: 20, label: '20%' },
  { value: 25, label: '25%' },
  { value: 30, label: '30%' },
  { value: 50, label: '50%' },
  { value: 100, label: '100%' }
]

export const REP_NAME_OPTIONS = [
  'Jim Bartolotta', 'Geoff Nicholson', 'Hans Lemus', 'Mike Markham', 'House Account'
]

export const ADMIN_ROUTES = [
  'admin',
  'new-address-approval',
  'update-approval-request',
  'stock',
  'user-permission',
  'create-user-permission',
  'edit-user-permission',
  'new-buyer-approval',
  'approvals',
  'new-account-approval',
  'companies',
  'buyers',
  'addresses',
  'admin-buyers',
  'new-buyer',
  'update-account-approval',
  'coupons',
  'coupon-create',
  'coupon-update',
  'imagery',
  'imagery-management',
  'brands',
  'shipping-methods',
  'orders-config',
  'mega-menu',
  'page-headers'

]

export const ERRORS = [422, 401, 400, 404]


export const REQUEST_TYPE = Object.freeze({
  NEW_ACCOUNT: 'New Account',
  NEW_BUYER: 'New Buyer',
  CREATE_ADDRESS: 'Create Address',
  UPDATE_ADDRESS: 'Update Address',
  CHANGE_ADDRESS: 'Change Address',
  DELETE_ADDRESS: 'Delete Address',
  UPDATE_REQUEST: 'Update Request',
  CREATE_BUYER: 'Create Buyer',
  UPDATE_BUYER: 'Update Buyer',
  DELETE_BUYER: 'Delete Buyer',
  DEFAULT_BUYER: 'Default Buyer'
});

export const USERS_ROLES = [
  'admin', 'buyer', 'associate'
]

export const ROLES = {
  COMPANY_ADMIN: 'company_admin',
  ADMIN: 'admin',
  BUYER: 'buyer',
  ASSOCIATE: 'associate'
};

export const PERMISSIONS = {
  SUBMIT_ORDERS: "submit_orders",
  ORDER_HISTORY: "order_history",
  DRAFT_ORDERS: "draft_orders",
  DELETE_USERS: "delete_users",
  UPDATE_USERS: "update_users",
  CREDIT_CARD: "credit_card",
  ADDRESS_BOOK: "address_book",
  WHOLESALE_COST: "wholesale_cost",
  COLLECTION: "collection",
  TAG: "tag"
};

export const DEFAULT_PACIFIC_MAIL = 'info@pacificsilk.net'
export const DEFAULT_PACIFIC_PHONE = '(949) 496-8484'
export const DEFAULT_PACIFIC_ORDERS_MAIL = 'orders@pacificsilk.net'

export const LAST_NON_ADMIN_ROUTE = 'last_non_admin_route'
